(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // --- Load More Button Logic ---
  document.addEventListener('click', function(e) {
    const button = e.target.closest('#load-more-button');
    if (!button) return;

    const nextUrl = button.getAttribute('data-next-url');
    button.innerText = 'Loading...';

    fetch(nextUrl)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Naye products ko list mein add karna
        const newProducts = doc.querySelectorAll('.product-grid__item');
        const gridContainer = document.querySelector('.collection-wrapper .grid'); // UI element selector
        
        newProducts.forEach(prod => {
           // Yahan hum render 'product-grid' ke andar ke actual products list ko target karenge
           const targetGrid = document.querySelector('.product-grid') || gridContainer;
           targetGrid.appendChild(prod);
        });

        // Button update ya remove karna
        const newButton = doc.querySelector('#load-more-button');
        if (newButton) {
          button.setAttribute('data-next-url', newButton.getAttribute('data-next-url'));
          button.innerText = 'Load More';
        } else {
          button.parentElement.remove(); // Button wrapper ko remove kar dena
        }
      })
      .catch(err => {
        console.error(err);
        button.innerText = 'Load More';
      });
  });

  } catch(e) { console.error(e); }
})();
})();
